function index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function admin() {
  return import(/* webpackChunkName: "page-admin" */ '@/pages/admin.vue')
}
function authenticationDetails() {
  return import(
    /* webpackChunkName: "page-authenticationDetails" */ '@/pages/authenticationDetails.vue'
  )
}
function changePassword() {
  return import(
    /* webpackChunkName: "page-changePassword" */ '@/pages/changePassword.vue'
  )
}
function changes() {
  return import(/* webpackChunkName: "page-changes" */ '@/pages/changes.vue')
}
function chat() {
  return import(/* webpackChunkName: "page-chat" */ '@/pages/chat.vue')
}
function confirmModal() {
  return import(
    /* webpackChunkName: "page-confirmModal" */ '@/pages/confirmModal.vue'
  )
}
function dashboard() {
  return import(
    /* webpackChunkName: "page-dashboard" */ '@/pages/dashboard.vue'
  )
}
function filters() {
  return import(/* webpackChunkName: "page-filters" */ '@/pages/filters.vue')
}
function forgetpass() {
  return import(
    /* webpackChunkName: "page-forgetpass" */ '@/pages/forgetpass.vue'
  )
}
function formHelpBox() {
  return import(
    /* webpackChunkName: "page-formHelpBox" */ '@/pages/formHelpBox.vue'
  )
}
function forms() {
  return import(/* webpackChunkName: "page-forms" */ '@/pages/forms.vue')
}
function globalSnackbar() {
  return import(
    /* webpackChunkName: "page-globalSnackbar" */ '@/pages/globalSnackbar.vue'
  )
}
function loading() {
  return import(/* webpackChunkName: "page-loading" */ '@/pages/loading.vue')
}
function login() {
  return import(/* webpackChunkName: "page-login" */ '@/pages/login.vue')
}
function logout() {
  return import(/* webpackChunkName: "page-logout" */ '@/pages/logout.vue')
}
function passwordVerification() {
  return import(
    /* webpackChunkName: "page-passwordVerification" */ '@/pages/passwordVerification.vue'
  )
}
function persianNumber() {
  return import(
    /* webpackChunkName: "page-persianNumber" */ '@/pages/persianNumber.vue'
  )
}
function portal() {
  return import(/* webpackChunkName: "page-portal" */ '@/pages/portal.vue')
}
function profile() {
  return import(/* webpackChunkName: "page-profile" */ '@/pages/profile.vue')
}
function profilePhoto() {
  return import(
    /* webpackChunkName: "page-profilePhoto" */ '@/pages/profilePhoto.vue'
  )
}
function register() {
  return import(/* webpackChunkName: "page-register" */ '@/pages/register.vue')
}
function reports() {
  return import(/* webpackChunkName: "page-reports" */ '@/pages/reports.vue')
}
function server() {
  return import(/* webpackChunkName: "page-server" */ '@/pages/server.vue')
}
function starter() {
  return import(/* webpackChunkName: "page-starter" */ '@/pages/starter.vue')
}
function stepper() {
  return import(/* webpackChunkName: "page-stepper" */ '@/pages/stepper.vue')
}
function underConstruction() {
  return import(
    /* webpackChunkName: "page-underConstruction" */ '@/pages/underConstruction.vue'
  )
}
function contracts_index() {
  return import(
    /* webpackChunkName: "page-contracts-index" */ '@/pages/contracts/index.vue'
  )
}
function editUserInfos_index() {
  return import(
    /* webpackChunkName: "page-editUserInfos-index" */ '@/pages/editUserInfos/index.vue'
  )
}
function leaves_index() {
  return import(
    /* webpackChunkName: "page-leaves-index" */ '@/pages/leaves/index.vue'
  )
}
function messages_index() {
  return import(
    /* webpackChunkName: "page-messages-index" */ '@/pages/messages/index.vue'
  )
}
function payrolls_index() {
  return import(
    /* webpackChunkName: "page-payrolls-index" */ '@/pages/payrolls/index.vue'
  )
}
function personGroups_index() {
  return import(
    /* webpackChunkName: "page-personGroups-index" */ '@/pages/personGroups/index.vue'
  )
}
function userMessages_index() {
  return import(
    /* webpackChunkName: "page-userMessages-index" */ '@/pages/userMessages/index.vue'
  )
}
function userPayrolls_index() {
  return import(
    /* webpackChunkName: "page-userPayrolls-index" */ '@/pages/userPayrolls/index.vue'
  )
}
function users_index() {
  return import(
    /* webpackChunkName: "page-users-index" */ '@/pages/users/index.vue'
  )
}
function contracts_add() {
  return import(
    /* webpackChunkName: "page-contracts-add" */ '@/pages/contracts/add.vue'
  )
}
function contracts_edit() {
  return import(
    /* webpackChunkName: "page-contracts-edit" */ '@/pages/contracts/edit.vue'
  )
}
function leaves_add() {
  return import(
    /* webpackChunkName: "page-leaves-add" */ '@/pages/leaves/add.vue'
  )
}
function messages_add() {
  return import(
    /* webpackChunkName: "page-messages-add" */ '@/pages/messages/add.vue'
  )
}
function payrolls_add() {
  return import(
    /* webpackChunkName: "page-payrolls-add" */ '@/pages/payrolls/add.vue'
  )
}
function payrolls_addGroup() {
  return import(
    /* webpackChunkName: "page-payrolls-addGroup" */ '@/pages/payrolls/addGroup.vue'
  )
}
function personGroups_add() {
  return import(
    /* webpackChunkName: "page-personGroups-add" */ '@/pages/personGroups/add.vue'
  )
}
function users_add() {
  return import(
    /* webpackChunkName: "page-users-add" */ '@/pages/users/add.vue'
  )
}
function users_edit() {
  return import(
    /* webpackChunkName: "page-users-edit" */ '@/pages/users/edit.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: index,
    meta: {
      order: 1,
      isVisible: true,
      iconName: 'mdi-home',
      roles: ['Admin'],
    },
  },
  {
    name: 'admin',
    path: 'admin',
    component: admin,
    meta: {
      order: 1.1,
      isVisible: false,
      iconName: 'mdi-play',
      roles: ['ADMIN'],
    },
  },
  {
    name: 'authenticationDetails',
    path: 'authenticationDetails',
    component: authenticationDetails,
    meta: {
      title: 'authenticationDetails',
      order: 10,
      isVisible: false,
      iconName: 'mdi-login',
      artwork: '/img/samples/auth-artwork.png',
    },
  },
  {
    name: 'changePassword',
    path: 'changePassword',
    component: changePassword,
    meta: {
      title: 'change password',
      order: 9,
      isVisible: false,
      iconName: 'mdi-login',
      artwork: '/img/samples/auth-artwork.png',
    },
  },
  {
    name: 'changes',
    path: 'changes',
    component: changes,
    meta: {
      order: 20,
      isVisible: false,
      iconName: 'mdi-file-document-edit',
    },
  },
  {
    name: 'chat',
    path: 'chat',
    component: chat,
    meta: {
      order: 7,
      isVisible: false,
      iconName: 'mdi-arrow-left',
    },
  },
  {
    name: 'confirmModal',
    path: 'confirmModal',
    component: confirmModal,
    meta: {
      order: 20,
      isVisible: false,
      iconName: 'mdi-arrow-left',
    },
  },
  {
    name: 'dashboard',
    path: 'dashboard',
    component: dashboard,
    meta: {
      order: 2,
      isVisible: false,
      iconName: 'mdi-book',
    },
  },
  {
    name: 'filters',
    path: 'filters',
    component: filters,
    meta: {
      order: 7,
      isVisible: false,
      iconName: 'mdi-arrow-left',
    },
  },
  {
    name: 'forgotpass',
    path: 'forgetpass',
    component: forgetpass,
    meta: {
      order: 7,
      isVisible: false,
      iconName: 'mdi-lock-open',
      artwork: '/img/samples/auth-artwork.png',
    },
  },
  {
    name: 'formHelpBox',
    path: 'formHelpBox',
    component: formHelpBox,
    meta: {
      order: 18,
      isVisible: false,
      iconName: 'mdi-help',
    },
  },
  {
    name: 'forms',
    path: 'forms',
    component: forms,
    meta: {
      order: 4.1,
      isVisible: false,
      iconName: 'mdi-pen',
    },
  },
  {
    name: 'globalSnackbar',
    path: 'globalSnackbar',
    component: globalSnackbar,
    meta: {
      order: 19,
      isVisible: false,
      iconName: 'mdi-arrow-left',
    },
  },
  {
    name: 'loading',
    path: 'loading',
    component: loading,
    meta: {
      order: 7,
      isVisible: false,
      iconName: 'mdi-arrow-left',
    },
  },
  {
    name: 'login',
    path: 'login',
    component: login,
    meta: {
      order: 5,
      isVisible: false,
      iconName: 'mdi-email',
      artwork: '/img/samples/auth-artwork.png',
    },
  },
  {
    name: 'logout',
    path: 'logout',
    component: logout,
    meta: {
      order: 7,
      isVisible: false,
      iconName: 'mdi-arrow-left',
    },
  },
  {
    name: 'passwordVerification',
    path: 'passwordVerification',
    component: passwordVerification,
    meta: {
      title: 'enter current password',
      order: 9,
      isVisible: false,
      iconName: 'mdi-login',
      artwork: '/img/samples/auth-artwork.png',
    },
  },
  {
    name: 'persianNumber',
    path: 'persianNumber',
    component: persianNumber,
    meta: {
      order: 7,
      isVisible: false,
      iconName: 'mdi-arrow-left',
    },
  },
  {
    name: 'portal',
    path: 'portal',
    component: portal,
    meta: {
      order: 7,
      isVisible: false,
      iconName: 'mdi-arrow-left',
      artwork: null,
    },
  },
  {
    name: 'profile',
    path: 'profile',
    component: profile,
    meta: {
      order: 13,
      isVisible: false,
      iconName: 'mdi-account',
    },
  },
  {
    name: 'profilePhoto',
    path: 'profilePhoto',
    component: profilePhoto,
    meta: {
      order: 7,
      isVisible: false,
      iconName: 'mdi-arrow-left',
    },
  },
  {
    name: 'register',
    path: 'register',
    component: register,
    meta: {
      order: 6,
      isVisible: false,
      iconName: 'mdi-login',
      artwork: '/img/samples/auth-artwork.png',
    },
  },
  {
    name: 'reports',
    path: 'reports',
    component: reports,
    meta: {
      order: 4.2,
      isVisible: false,
      iconName: 'mdi-book',
    },
  },
  {
    name: 'server',
    path: 'server',
    component: server,
    meta: {
      order: 7,
      isVisible: false,
      iconName: 'mdi-arrow-left',
    },
  },
  {
    name: 'starter',
    path: 'starter',
    component: starter,
    meta: {
      order: 7,
      isVisible: false,
      iconName: 'mdi-arrow-left',
    },
  },
  {
    name: 'stepper',
    path: 'stepper',
    component: stepper,
    meta: {
      order: 3.1,
      isVisible: false,
      iconName: 'mdi-pen',
    },
  },
  {
    name: 'underConstruction',
    path: 'underConstruction',
    component: underConstruction,
    meta: {
      order: 21,
      isVisible: false,
      iconName: 'mdi-account-hard-hat',
      artwork: '/img/samples/auth-artwork.png',
    },
  },
  {
    name: 'contracts',
    path: 'contracts',
    component: contracts_index,
    meta: {
      order: 4,
      isVisible: true,
      iconName: 'mdi-book',
      roles: ['Admin'],
    },
  },
  {
    name: 'editUserInfos',
    path: 'editUserInfos',
    component: editUserInfos_index,
    meta: {
      order: 5,
      isVisible: true,
      iconName: 'mdi-pen',
      roles: ['User', 'SuperUser'],
    },
  },
  {
    name: 'leaves',
    path: 'leaves',
    component: leaves_index,
    meta: {
      order: 4,
      isVisible: true,
      iconName: 'mdi-account-arrow-right',
      roles: ['Admin', 'SuperUser', 'User'],
    },
  },
  {
    name: 'messages',
    path: 'messages',
    component: messages_index,
    meta: {
      order: 4.01,
      isVisible: true,
      iconName: 'mdi-message',
      roles: ['Admin'],
    },
  },
  {
    name: 'payrolls',
    path: 'payrolls',
    component: payrolls_index,
    meta: {
      order: 3,
      isVisible: true,
      iconName: 'mdi-cash-multiple',
      roles: ['Admin'],
    },
  },
  {
    name: 'personGroups',
    path: 'personGroups',
    component: personGroups_index,
    meta: {
      order: 4,
      isVisible: true,
      iconName: 'mdi-account-group',
      roles: ['Admin'],
    },
  },
  {
    name: 'userMessages',
    path: 'userMessages',
    component: userMessages_index,
    meta: {
      order: 4,
      isVisible: true,
      iconName: 'mdi-message',
      roles: ['User', 'SuperUser'],
    },
  },
  {
    name: 'userPayrolls',
    path: 'userPayrolls',
    component: userPayrolls_index,
    meta: {
      order: 3,
      isVisible: true,
      iconName: 'mdi-cash-multiple',
      roles: ['User', 'SuperUser'],
    },
  },
  {
    name: 'users',
    path: 'users',
    component: users_index,
    meta: {
      order: 2,
      isVisible: true,
      iconName: 'mdi-account',
      roles: ['Admin'],
    },
  },
  {
    name: 'addContracts',
    path: 'contracts/add',
    component: contracts_add,
    meta: {
      order: 4,
      isVisible: false,
      iconName: 'mdi-arrow-left',
      roles: ['admin'],
    },
  },
  {
    name: 'editContracts',
    path: 'contracts/edit',
    component: contracts_edit,
    meta: {
      order: 4,
      isVisible: false,
      iconName: 'mdi-arrow-left',
      roles: ['admin'],
    },
  },
  {
    name: 'addLeaves',
    path: 'leaves/add',
    component: leaves_add,
    meta: {
      order: 4,
      isVisible: false,
      iconName: 'mdi-arrow-left',
      roles: ['User', 'Admin', 'SuperUser'],
    },
  },
  {
    name: 'addPayrolls',
    path: 'messages/add',
    component: messages_add,
    meta: {
      order: 4,
      isVisible: false,
      iconName: 'mdi-arrow-left',
    },
  },
  {
    name: 'addPayrolls',
    path: 'payrolls/add',
    component: payrolls_add,
    meta: {
      order: 4,
      isVisible: false,
      iconName: 'mdi-arrow-left',
    },
  },
  {
    name: 'addGroupPayrolls',
    path: 'payrolls/addGroup',
    component: payrolls_addGroup,
    meta: {
      order: 4,
      isVisible: false,
      iconName: 'mdi-arrow-left',
    },
  },
  {
    name: 'addPersonGroups',
    path: 'personGroups/add',
    component: personGroups_add,
    meta: {
      order: 4,
      isVisible: false,
      iconName: 'mdi-arrow-left',
      roles: ['User', 'Admin', 'SuperUser'],
    },
  },
  {
    name: 'addUsers',
    path: 'users/add',
    component: users_add,
    meta: {
      order: 4,
      isVisible: false,
      iconName: 'mdi-arrow-left',
    },
  },
  {
    name: 'editUsers',
    path: 'users/edit',
    component: users_edit,
    meta: {
      order: 4,
      isVisible: false,
      iconName: 'mdi-arrow-left',
    },
  },
]
